
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {CoachPlayersProfileDiagnosticsListFormRemove} from "@/models/app/coach/players/profile/diagnostics/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "diagnostic",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class CoachPlayersProfileDiagnosticsListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  diagnostic: CoachPlayersProfileDiagnosticsListFormRemove = new CoachPlayersProfileDiagnosticsListFormRemove();

  formData: CoachPlayersProfileDiagnosticsListFormRemove = new CoachPlayersProfileDiagnosticsListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/diagnostic/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getDiagnostics');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.diagnostic;
  }

  resetFormData(): void {
    this.formData = new CoachPlayersProfileDiagnosticsListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
